import React from "react";
import "./MessageBar.css";

type MessageBarProps = {
    message: string;
}

const MESSAGE_SHOW_MILLI_SECONDS = 5000;
const DELAY_HIDE_MILLI_SECONDS = 500;

/**
 * message が変わるごとに 一定時間表示。
 * 現状、 props.message (string) をトリガにしてるので、 同じメッセージが連続した際には表示されない
 *
 */
export const MessageBar = (props: MessageBarProps) => {

    const [message, setMessage] = React.useState('');
    const [class_name, setClassName] = React.useState<'show' | 'hide'>('hide');
    const current_state = React.useRef<'ready' | 'used'>('ready');
    const pending_messages = React.useRef<string[]>([]);
    const after_hide_timer = React.useRef<NodeJS.Timeout | null>(null);

    React.useEffect(() => {
        // console.log("MessageBar.useEffect: props.message", props.message);

        if (props.message === '') {
            return;
        }

        if (current_state.current === 'ready') {
            if (after_hide_timer.current) {
                clearTimeout(after_hide_timer.current);
                after_hide_timer.current = null;
            }
            setMessage(props.message);
        } else {
            pending_messages.current.push(props.message);
        }

    }, [props.message]);

    React.useEffect(() => {
        // console.log("MessageBar.useEffect: message", message);

        if (message === '') {
            return;
        }

        if (current_state.current === 'ready') {
            current_state.current = 'used';
            setClassName('show');
            setTimeout(() => {
                setClassName('hide');
                after_hide_timer.current = setTimeout(afterHide, DELAY_HIDE_MILLI_SECONDS);
            }, MESSAGE_SHOW_MILLI_SECONDS);
        }

    }, [message]);

    function afterHide() {
        // console.log("MessageBar.afterHide", pending_messages);

        current_state.current = 'ready';
        after_hide_timer.current = null;

        const message = pending_messages.current.shift();
        if (message !== undefined) {
            setMessage(message);
        }
    }

    return <div className={`message-bar ${class_name}`}>{message}</div>
}
